import React, { useState, useEffect } from "react";
import { Container, Row, Col, Spinner } from "react-bootstrap";

import notFoundBg from "../../assets/404.png";

import "./NotFound.css";

const NotFoundPage = () => {
  //loading
  const [loadingNotFound, setloadingNotFound] = useState(true);

  useEffect(() => {
    const timer = setTimeout(() => setloadingNotFound(false), 1000); // 1s delay
    return () => clearTimeout(timer);
  }, []);

  if (loadingNotFound) {
    return (
      <div className="d-flex justify-content-center align-items-center vh-100">
        <Spinner animation="border" variant="primary" />
      </div>
    );
  }

  return (
    <section className="not-found-pagesection">
      <Container fluid className="not-found-pagesection-container">
        <Row className="not-found-pagesection-row">
          <Col className="not-found-pagesection-col d-flex justify-content-center align-items-center">
            <div className="not-found-pagesection-wrapper text-center">
              <img
                src={notFoundBg}
                alt="404 Illustration"
                className="not-found-pagesection-image"
              />

              <p className="not-found-pagesection-text">
                Oops! The page you were looking for couldn’t be found.
              </p>
            </div>
          </Col>
        </Row>
      </Container>
    </section>
  );
};

export default NotFoundPage;
